@if (withButton()) {
	<div class="button-wrapper">
		<mat-chip-option
			class="toggle-card-button"
			(click)="toggleCardVisibility()"
			[title]="'ai_image_upload_title' | translate"
			[selected]="isCardVisible()"
		>
			<div class="ai-chip-content">
				@if (!isCardVisible()) {
					<mat-icon svgIcon="smart-stars"></mat-icon>
				}
				<span>{{ 'ai_image_upload_title' | translate }}</span>
			</div>
		</mat-chip-option>
	</div>
}

@if (isCardVisible()) {
	<div class="ai-image-upload-container">
		<div class="title-wrapper">
			<mat-icon svgIcon="smart-stars" />
			<h3>{{ 'ai_image_upload_title' | translate }}</h3>
		</div>

		<p>
			{{ 'ai_image_upload_description' | translate }}
		</p>

		<div class="footer-wrapper">
			<div class="info-buttons-wrapper">
				<div class="info-wrapper" (click)="openAiImageTipsDialog()">
					<mat-icon>tips_and_updates</mat-icon>
					<span>{{ 'tips' | translate }}</span>
				</div>

				<div class="info-wrapper" (click)="openAiInfoDialog()">
					<mat-icon>info</mat-icon>
					<span>{{ 'use_of_ai' | translate }}</span>
				</div>
			</div>

			<input
				type="file"
				(change)="onFileSelected($event)"
				#fileInput
				hidden
				accept="image/*"
				multiple
			/>
			<div class="buttons-container">
				<button
					[matButton]="hasExistingImages() ? 'outlined' : 'elevated'"
					[class.primary]="!hasExistingImages()"
					[class.accent]="hasExistingImages()"
					(click)="triggerFileInput(fileInput)"
					title="{{ 'analyze_new_tooltip' | translate }}"
				>
					<mat-icon svgIcon="upload"></mat-icon>
					<span>{{ 'analyze_new_title' | translate }}</span>
				</button>

				@if (hasExistingImages()) {
					<button
						matButton="elevated"
						class="primary"
						(click)="analyzeExistingImages()"
						title="{{ 'analyze_existing_tooltip' | translate }}"
					>
						<mat-icon svgIcon="smart-stars"></mat-icon>
						<span>{{ 'analyze_existing_text' | translate }}</span>
					</button>
				}
			</div>
		</div>
	</div>
}
